import type { Action } from "../../actions/types";
import get from "lodash/get";

export interface StoreState {
  retrieved: boolean;
  totalCredits: number;
  approvedCredits: number;
  pendingCredits: number;
  tierResult: {
    currentTier: number;
    isNextTier: boolean;
    creditsToNextTier: number;
    nextTier: number | string;
  };
}

export const initialState: StoreState = {
  retrieved: false,
  totalCredits: 0,
  approvedCredits: 0,
  pendingCredits: 0,
  tierResult: {
    currentTier: 0,
    isNextTier: false,
    creditsToNextTier: 0,
    nextTier: 0,
  },
};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "GET_REWARD_STATS_SUCCESS": {
      const stats = get(action, "response.data.advocateCredits", state);
      const tierResult = get(stats, "tierResult", initialState.tierResult);

      return {
        ...stats,
        tierResult: {
          ...stats.tierResult,
          nextTier: tierResult.isNextTier
            ? tierResult.currentTier + 1
            : tierResult.currentTier,
        },
        retrieved: true,
        approvedCredits: stats.totalCredits - stats.pendingCredits,
      };
    }

    default:
      return state;
  }
}
